const state = {
  apiUrl: null,
  currentQuestion: null,
  questions: [],
  userData: null
}

export default state
